import * as normalize_raw from 'bundle-text:normalize.css';
import { unsafeCSS } from 'lit';

export const normalize = unsafeCSS(normalize_raw);
